import { render, staticRenderFns } from "./tabCut1920.vue?vue&type=template&id=775d5df6&scoped=true&"
import script from "./tabCut1920.vue?vue&type=script&lang=js&"
export * from "./tabCut1920.vue?vue&type=script&lang=js&"
import style0 from "./tabCut1920.vue?vue&type=style&index=0&id=775d5df6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "775d5df6",
  null
  
)

export default component.exports